import { render } from "./mineDemo.vue?vue&type=template&id=46399dce&scoped=true"
import script from "./mineDemo.vue?vue&type=script&lang=js"
export * from "./mineDemo.vue?vue&type=script&lang=js"

import "../assets/css/game_mine.css?vue&type=style&index=0&id=46399dce&scoped=true&lang=css"
import "./mineDemo.vue?vue&type=style&index=1&id=46399dce&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46399dce"]])

export default __exports__